import { Title } from 'components'
import { Table } from '@sar/component'

import { Row } from 'antd'
import { ProForm, ModalForm, ProFormText, ProFormList, ProFormDependency, ProFormSelect, ProFormTreeSelect, ProFormDatePicker, ProFormDateTimePicker, ProFormTextArea } from '@ant-design/pro-components'

async function fetchData(params, store) {
  const result = await store.externals.api.get(`/customers`, {
    params: Object.assign(params, {
      page: params.current,
      size: params.pageSize,
    })
  })

  return {
    success: true,
    data: result.data,
    total: result.totals,
  }
}

function Create ({ store, navigator }) {
  const customerStage = React.useMemo(() => {
    return store.config.getConstantPairs(`CustomerStage`)
  }, [])

  return <div className='m-4 p-4 bg-white'>
    <ProForm
      grid={true}
      rowProps={{ gutter: 16 }}
      layout='vertical'
      className='max-w-[900px]'
      onFinish={data => store.externals.api.post(`/customers`, data).then(() => navigator.back())}
    >
      <ProFormTreeSelect
        name='sourceId'
        label='客户信息来源'
        colProps={{ xs: 12 }}
        rules={[ { required: true, message: '请输入客户信息来源' } ]}
        request={() => store.externals.api.get(`/constant/source`)}
        fieldProps={{ fieldNames: { value: 'id', label: 'source' } }}
      />

      <ProFormText
        name='projectName'
        label='项目名称'
        colProps={{ xs: 12 }}
      />

      <ProFormText
        name='name'
        label='姓名'
        colProps={{ xs: 12 }}
        rules={[ { required: true, message: '请输入姓名' } ]}
      />

      <ProFormDependency name={[ 'stage' ]}>
        {({ stage }) => {
          return <ProFormText
            name='contactNumber'
            label='联系方式'
            colProps={{ xs: 12 }}
            rules={[ { required: stage == 2, message: '请输入联系方式' }, { pattern: /^1\d{10}$/, message: '请输入正确的电话号码' } ]}
          />
        }}
      </ProFormDependency>

      <ProFormText
        name='wechat'
        label='微信号'
        colProps={{ xs: 12 }}
      />

      <ProFormSelect
        showSearch
        name='assignedEmployeeId'
        label='跟踪人员'
        colProps={{ xs: 12 }}
        request={() => store.externals.api.get(`/emp/all`)}
        debounceTime={3000}
        fieldProps={{ optionFilterProp: 'nickname', fieldNames: { label: 'nickname', value: 'id' } }}
      />

      <ProFormDateTimePicker
        name='communicationTime'
        label='签单时间'
        width='lg'
        fieldProps={{ width: '100%' }}
        colProps={{ xs: 12 }}
      />

      <ProFormText
        name='address'
        label='地址'
        colProps={{ xs: 12 }}
      />

      <ProFormText
        name='inquiry'
        label='咨询内容'
        colProps={{ xs: 12 }}
      />

      <ProFormTextArea
        name='remark'
        label='备注'
        colProps={{ xs: 24 }}
        fieldProps={{ rows: 4 }}
      />

      <ProFormList
        name='trackList'
        label='跟踪反馈表'
        alwaysShowItemLabel={false}
        creatorRecord={() => ({ trackTime: moment().format('YYYY-MM-DD') })}
        itemRender={(dom, meta) => {
          return <div className='flex items-end'>
            <div className='flex-auto'>
              {dom.listDom}
            </div>

            <div className='flex-none'>
              {dom.action}
            </div>
          </div>
        }}
      >
        <Row gutter={16} className='px-4'>
          <ProFormText
            readonly
            name='trackTime'
            label='跟踪时间'
            colProps={{ xs: 8 }}
          />

          <ProFormText
            name='feedback'
            label='反馈'
            colProps={{ xs: 16 }}
          />
        </Row>
      </ProFormList>

      <ProFormSelect
        name='stage'
        label='客户进度'
        colProps={{ xs: 12 }}
        valueEnum={store.config.getConstantEnums(`CustomerStage`)}
      />

      <ProFormDatePicker
        name='reminderTime'
        label='下次跟单时间'
        width='lg'
        colProps={{ xs: 12 }}
      />

      <ProFormDependency name={[ 'stage' ]}>
        {({ stage }) => {
          if (stage != customerStage.close) {
            return null
          }

          else {
            return <ProFormTextArea
              name='noDealReason'
              label='不成交原因'
              fieldProps={{ rows: 4 }}
              rules={[ { required: true, message: '请输入不成交原因' } ]}
            />
          }
        }}
      </ProFormDependency>
    </ProForm>
  </div>
}

function Update ({ store, navigator, params }) {
  const customerStage = React.useMemo(() => {
    return store.config.getConstantPairs(`CustomerStage`)
  }, [])

  return <div className='m-4 p-4 bg-white'>
    <ProForm
      grid={true}
      rowProps={{ gutter: 16 }}
      layout='vertical'
      className='max-w-[900px]'
      submitter={store.identity.hasPermission('/customer/prospective:update')}
      readonly={!store.identity.hasPermission('/customer/prospective:update')}
      request={() => store.externals.api.get(`/customers/${params.id}`)}
      onFinish={data => store.externals.api.put(`/customers/${params.id}`, data).then(() => navigator.back())}
    >
      <ProFormTreeSelect
        name='sourceId'
        label='客户信息来源'
        colProps={{ xs: 12 }}
        rules={[ { required: true, message: '请输入客户信息来源' } ]}
        request={() => store.externals.api.get(`/constant/source`)}
        fieldProps={{ fieldNames: { value: 'id', label: 'source' } }}
      />

      <ProFormText
        name='projectName'
        label='项目名称'
        colProps={{ xs: 12 }}
      />

      <ProFormText
        name='name'
        label='姓名'
        colProps={{ xs: 12 }}
        rules={[ { required: true, message: '请输入姓名' } ]}
      />

      <ProFormDependency name={[ 'stage' ]}>
        {({ stage }) => {
          return <ProFormText
            name='contactNumber'
            label='联系方式'
            colProps={{ xs: 12 }}
            rules={[ { required: stage == 2, message: '请输入联系方式' }, { pattern: /^1\d{10}$/, message: '请输入正确的电话号码' } ]}
          />
        }}
      </ProFormDependency>

      <ProFormText
        name='wechat'
        label='微信号'
        colProps={{ xs: 12 }}
      />

      <ProFormSelect
        showSearch
        name='assignedEmployeeId'
        label='跟踪人员'
        colProps={{ xs: 12 }}
        request={() => store.externals.api.get(`/emp/all`)}
        debounceTime={3000}
        fieldProps={{ optionFilterProp: 'nickname', fieldNames: { label: 'nickname', value: 'id' } }}
      />

      <ProFormDateTimePicker
        name='communicationTime'
        label='签单时间'
        width='lg'
        fieldProps={{ width: '100%' }}
        colProps={{ xs: 12 }}
      />

      <ProFormText
        name='address'
        label='地址'
        colProps={{ xs: 12 }}
      />

      <ProFormText
        name='inquiry'
        label='咨询内容'
        colProps={{ xs: 12 }}
      />

      <ProFormTextArea
        name='remark'
        label='备注'
        colProps={{ xs: 24 }}
        fieldProps={{ rows: 4 }}
      />

      <ProFormList
        name='trackList'
        label='跟踪反馈表'
        creatorRecord={() => ({ trackTime: moment().format('YYYY-MM-DD') })}
        itemRender={(dom, meta) => {
          return <div className='flex items-end'>
            <div className='flex-auto'>
              {dom.listDom}
            </div>

            <div className='flex-none w-64'>
              {meta.record?.id ? null : dom.action}
            </div>
          </div>
        }}
      >
        {(_, __, ref) => {
          return <Row gutter={16} className='px-4'>
            <ProFormText
              readonly
              name='trackTime'
              label='跟踪时间'
              colProps={{ xs: 8 }}
            />

            <ProFormText
              readonly={ref.getCurrentRowData().id != null}
              name='feedback'
              label='反馈'
              colProps={{ xs: 16 }}
            />
          </Row>
        }}
      </ProFormList>

      <ProFormSelect
        name='stage'
        label='客户进度'
        colProps={{ xs: 12 }}
        valueEnum={store.config.getConstantEnums(`CustomerStage`)}
      />

      <ProFormDatePicker
        name='reminderTime'
        label='下次跟单时间'
        width='lg'
        colProps={{ xs: 12 }}
      />

      <ProFormDependency name={[ 'stage' ]}>
        {({ stage }) => {
          if (stage != customerStage.close) {
            return null
          }

          else {
            return <ProFormTextArea
              name='noDealReason'
              label='不成交原因'
              fieldProps={{ rows: 4 }}
              rules={[ { required: true, message: '请输入不成交原因' } ]}
            />
          }
        }}
      </ProFormDependency>
    </ProForm>
  </div>
}

function Convert ({ data, store, visible, handles, onVisibleChange }) {
  return <ModalForm
    title='转为客户或经销商'
    layout='vertical'
    width={500}
    open={visible}
    modalProps={{
      centered: true,
      maskClosable: false,
      destroyOnClose: true,
    }}
    initialValues={{ target: 'customer' }}
    onOpenChange={onVisibleChange}
    request={async () => data}
    onFinish={res => (res.target == 'customer' ? store.externals.api.put(`/customers/convert/${data.id}`) : store.externals.api.put(`/customers/convertDealer/${data.id}`)).then(() => setTimeout(() => handles.current.reload())).then(R.T)}
  >
    <ProFormSelect
      name='target'
      label='转换目标'
      rules={[ { required: true, message: '请选择转换目标' } ]}
      valueEnum={{ customer: '转为客户', dealer: '转为经销商' }}
    />
  </ModalForm>
}

function List ({ store, navigator }) {
  const columns = [
    {
      title: '客户姓名',
      dataIndex: 'name',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '客户姓名' }),
    },
    {
      title: '联系电话',
      dataIndex: 'contactNumber',
      render: _ => _.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '联系电话' }),
    },
    {
      title: '地址',
      dataIndex: 'address',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '地址' }),
    },
    {
      title: '来源',
      dataIndex: 'sourceId',
      valueType: 'treeSelect',
      debounceTime: 300,
      hideInTable: true,
      request: () => store.externals.api.get(`/constant/source`),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ fieldNames: { value: 'id', label: 'source' }, placeholder: '来源' }),
    },
    {
      title: '微信号',
      dataIndex: 'wechat',
    },
    {
      title: '跟踪阶段',
      dataIndex: 'stage',
      valueType: 'select',
      valueEnum: store.config.getConstantEnums(`CustomerStage`),
    },
    {
      title: '来源',
      dataIndex: 'source',
    },
    {
      title: '咨询内容',
      dataIndex: 'inquiry',
    },
    {
      title: '问题反馈结果',
      dataIndex: 'communicationResult',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      valueType: 'datetime',
    },
  ]

  const actions = [
    {
      name: '新增',
      type: 'normal',
      visible: () => store.identity.hasPermission('/customer/prospective:create'),
      onClick: () => navigator.to(`/customer/prospective/create`, `新增准客户`),
    },
  ]

  const rowActions = [
    {
      name: '修改',
      visible: () => store.identity.hasPermission('/customer/prospective:update'),
      onClick: (data) => navigator.to(`/customer/prospective/update/${data.id}`, `修改增准客户（${data.name}）`),
    },
    {
      name: '转为客户',
      form: props => <Convert {...props} store={store} />,
      visible: (data) => data.status == 'no' && store.identity.hasPermission('/customer/prospective:convert'),
    },
    {
      danger: true,
      name: '删除',
      confirmType: 'modal',
      confirmMessage: '您确定删除这个准客户吗？',
      visible: () => store.identity.hasPermission('/customer/prospective:delete'),
      onConfirm: (data, handles) => store.externals.api.delete(`/customers/${data.id}`).then(() => handles.current.reload()),
    },
  ]

  const cols = React.useMemo(() => {
    let showSearch = [
        'name'
      , 'contactNumber'
      , 'sourceId'
      , 'address'
    ]

    return columns.map(column => {
      if (showSearch.includes(column.dataIndex)) {
        return Object.assign(column)
      }

      else {
        return Object.assign(column, { hideInSearch: true })
      }
    })
  }, [])

  const onRow = React.useCallback(data => {
    if (data.reminderTime == null) {
      return null
    }

    else if (moment().isBefore(data.reminderTime, 'day')) {
      return null
    }

    else {
      return {
        className: 'text-red-600'
      }
    }
  }, [])

  return <div className='p-4'>
    <Table
      onRow={onRow}
      title='准客户列表'
      columns={cols}
      actions={actions}
      rowActions={rowActions}
      request={params => fetchData(params, store)}
      scroll={{ }}
      search={{ labelWidth: 'auto', defaultCollapsed: true, span: Object.assign({}, store.config.responsive, { xxl: 4 }) }}
    />
  </div>
}

export default function (prefix, app) {
  return app
    .useRoute(`${prefix}/update/:id`, Update)
    .useRoute(`${prefix}/create`, Create)
    .useRoute(`${prefix}/`, List)
}
